import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';
export const goldenPrairieMetadata = {
  id: 'golden-prairie',
  name: 'Golden Prairie',
  description:
    'An expansive heartland course of rolling native grass, broad horizons and deceptive strategic bunkering.',
  environmentPreset: 'afternoon',
  metadata: {
    location: 'Sunflower County, Kansas',
    regionType: 'open prairie',
    difficulty: 75,
    typicalWind: [11, 24] as const,
    greenSpeed: [10.5, 11] as const,
    firmness: 'medium-firm' as const,
    primaryChallenge: 'Crosswinds, preferred angles and native-grass misses',
    signatureHoles: [3, 8, 14, 18],
    tournamentEventId: 'event-6',
    previewTheme: 'golden-horizon',
    environmentPalette: {
      fairway: '#81924a',
      rough: '#b79548',
      bunker: '#d7bd7a',
      water: '#527d82',
      haze: '#e3ca8f',
    },
    vegetationStyle: 'waist-high bluestem and scattered cottonwood',
    terrainStyle: terrainPreset('prairie-rolls', 9, 210, 1.35).id,
  },
};
const pars = [4, 4, 5, 3, 4, 5, 4, 4, 3, 4, 5, 3, 4, 3, 4, 5, 4, 4],
  yards = [
    445, 420, 600, 190, 470, 575, 410, 315, 205, 455, 590, 150, 440, 135, 465, 565, 430, 520,
  ],
  names = [
    'Big Sky',
    'Crossing',
    'Wide Horizon',
    'Meadow',
    'Long Grass',
    'Homestead',
    'Angle',
    'Wind Sprint',
    'High Plains',
    'Wheat',
    'Three Shot',
    'Prairie Pots',
    'Sidehill',
    'Sand Ring',
    'Broad Choice',
    'Harvest',
    'Home Field',
    'Heartland',
  ];
const o: Partial<HolePlan>[] = [];
o[2] = {
  splitFairway: true,
  landingZones: [{ distance: 290, width: 85, preferredSide: 'right' }],
  trees: 0,
};
o[7] = { landingZones: [{ distance: 250, width: 55 }], bunkerCount: 4, trees: 0 };
o[13] = { bunkerCount: 7, greenRadius: 14, trees: 0 };
o[17] = { bunkerCount: 4, trees: 1 };
export const createGoldenPrairieDocument = () =>
  authorCourse({
    ...goldenPrairieMetadata,
    plans: plans(names, pars, yards, o).map((p) => ({ ...p, trees: p.trees ?? 2 })),
  });
